import { c as _c } from "react/compiler-runtime";
import { Box } from '@mui/material';
import type { StructuredContentDocument, StructuredContentDocumentWithRenderer } from '../../hydration/types';
import { renderStructuredContent } from '../../renderContext';
import { getChildHeadingId } from '../CreditCardsTableOfContents/utils';
export type ContentSectionProps = StructuredContentDocumentWithRenderer<{
  spacing?: {
    top?: number;
    bottom?: number;
  };
  children: StructuredContentDocument;
}>;
export const ContentSection = sccProps => {
  const $ = _c(14);
  const {
    props: t0
  } = sccProps;
  const {
    children,
    spacing
  } = t0;
  let t1;
  if ($[0] !== sccProps) {
    t1 = getChildHeadingId(sccProps);
    $[0] = sccProps;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  const headingId = t1;
  const t2 = spacing?.top;
  const t3 = spacing?.bottom;
  let t4;
  if ($[2] !== t2 || $[3] !== t3) {
    t4 = {
      mt: t2,
      mb: t3
    };
    $[2] = t2;
    $[3] = t3;
    $[4] = t4;
  } else {
    t4 = $[4];
  }
  let t5;
  if ($[5] !== headingId) {
    t5 = headingId && {
      "data-testid": `content-section-${headingId}`
    };
    $[5] = headingId;
    $[6] = t5;
  } else {
    t5 = $[6];
  }
  let t6;
  if ($[7] !== children) {
    t6 = renderStructuredContent(children);
    $[7] = children;
    $[8] = t6;
  } else {
    t6 = $[8];
  }
  let t7;
  if ($[9] !== headingId || $[10] !== t4 || $[11] !== t5 || $[12] !== t6) {
    t7 = <Box sx={t4} component="section" aria-labelledby={headingId} {...t5}>{t6}</Box>;
    $[9] = headingId;
    $[10] = t4;
    $[11] = t5;
    $[12] = t6;
    $[13] = t7;
  } else {
    t7 = $[13];
  }
  return t7;
};